import React, { memo } from 'react'
import { Card } from 'react-bootstrap'

import PerfectScrollbar from 'react-perfect-scrollbar'
import { connect, useDispatch } from 'react-redux'
import { numberFormat, formatDate } from 'utils'
import { analComBasicRequest } from 'containers/market/actions'
import { analComLeaderRequest } from 'containers/market/actions'
import { analComHolderRequest } from 'containers/market/actions'
import { analComRelatedRequest } from 'containers/market/actions'
import { analComSameIndustryRequest } from 'containers/market/actions'
import { analComIntroductionRequest } from 'containers/market/actions'
import { makeGetAnalComIntroduction } from 'lib/selector'
import { makeGetAnalComRelated } from 'lib/selector'
import { makeGetAnalComSameInd } from 'lib/selector'
import { makeGetAnalComHolder } from 'lib/selector'
import { makeGetAnalComLeader } from 'lib/selector'
import { makeGetAnalComBasic } from 'lib/selector'

import * as _ from 'lodash'
import Loading from 'components/loading'
import NoDataFound from 'components/noDataFound'
import { colorByChange } from 'utils'
import { log } from 'utils'
import { colorFix } from 'utils'

const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`

function usePrevious(value) {
  const ref = React.useRef()

  React.useEffect(() => {
    ref.current = value
  }, [value]) // Only re-run if value changes

  return ref.current
}

function PanelFiles(props) {
  const abortController = new AbortController()

  const [tabActive, setTabActive] = React.useState('GioiThieu')
  const [companyActive, setCompanyActive] = React.useState('CtyCon')
  const [leaderActive, setLeaderActive] = React.useState('BanLanhDao')
  const [isLoading, setIsLoading] = React.useState(false)

  const [ctyCungNganh, setCtyCungNganh] = React.useState([])

  const {
    symbol,
    analComIntroduction,
    analComBasic,
    analComSameInd,
    analComLeader,
    analComHolder,
    analComRelated,
    t,
    lang,
  } = props
  const dispatch = useDispatch()

  const preComSameInd = usePrevious(analComSameInd)

  const d = new Date()
  d.setDate(d.getDate() - 1)

  React.useEffect(() => {
    if (analComSameInd && !_.isEqual(analComSameInd, preComSameInd)) {
      getDataCtyCungNganh()
    }
  }, [analComSameInd])

  React.useEffect(() => {
    if (symbol) {
      getStockOverview()
      getCompanyBasic()
      getCompanySameInd()
      getCompanyLeader()
      getCompanyHolder()

      if (companyActive) getCtyCon()
    }
  }, [symbol])

  React.useEffect(() => {
    if (companyActive) getCtyCon()
  }, [companyActive])

  function getCtyCon() {
    let _param = ''
    switch (companyActive) {
      case 'CtyCon':
        _param = `ticker=${symbol}&relatedType=${'D933DCAE2B553EE0E055C3B42B92FC60'}`
        break
      case 'CtyLienKet':
        _param = `ticker=${symbol}&relatedType=${'D933DCAE2B563EE0E055C3B42B92FC60'}`
        break
      case 'CtyKhac':
        _param = `ticker=${symbol}&relatedType=${'D933DCAE2B583EE0E055C3B42B92FC60'}`
        break

      default:
        break
    }
    dispatch(analComRelatedRequest(_param))
  }

  function getDataCtyCungNganh() {
    setIsLoading(true)

    fetch(
      appUrl + 'pbapi/api/stockBoard/stocklist/' + analComSameInd.join(','),
      {
        signal: abortController.signal,
      }
    )
      .then((response) => response.json())
      .then((res) => {
        // log(res.data);
        if (res.status === 200 && res.data) {
          setCtyCungNganh(res.data)
        }
        setIsLoading(false)
      })
      .catch((error) => {
        log(error)
        setCtyCungNganh([])
        setIsLoading(false)
      })
  }

  function getStockOverview() {
    const params = { secCode: symbol, lang }
    dispatch(analComIntroductionRequest(params))
  }

  function getCompanyBasic() {
    const params = { secCode: symbol, lang }
    dispatch(analComBasicRequest(params))
  }

  function getCompanySameInd() {
    const params = { secCode: symbol }
    dispatch(analComSameIndustryRequest(params))
  }

  function getCompanyLeader() {
    const params = { secCode: symbol, lang }
    dispatch(analComLeaderRequest(params))
  }

  function getCompanyHolder() {
    const params = { secCode: symbol, lang }
    dispatch(analComHolderRequest(params))
  }

  // log(analComSameInd, analComLeader, analComHolder, analComRelated);

  // console.log(analComBasic)

  return (
    <div
      className="d-grid"
      style={{ gridTemplateColumns: '430px auto 285px 300px', gap: '8px' }}
    >
      <Card
        className="mt-2"
        style={{ height: 'calc(100vh - 185px)', background: '#020210' }}
      >
        <Card.Header className="d-flex py-0 pr-2 tabs-cash">
          <a
            className={'fz-14 ' + (tabActive === 'GioiThieu' ? 'active' : '')}
            style={{ padding: '8px 0' }}
            onClick={() => setTabActive('GioiThieu')}
          >
            {t('algo.ptcp.txt-Introduction')}
          </a>
          <a
            className={
              'fz-14 ' + (tabActive === 'ThongTinCoBan' ? 'active' : '')
            }
            style={{ padding: '8px 0' }}
            onClick={() => setTabActive('ThongTinCoBan')}
          >
            {t('algo.ptcp.txt-Basic-information')}
          </a>
        </Card.Header>
        <Card.Body className="p-0">
          {tabActive === 'GioiThieu' && (
            <div
              style={{
                padding: '15px 20px',
                textAlign: 'justify',
                lineHeight: '22px',
              }}
              className="txt-content fz-14"
              // dangerouslySetInnerHTML={{
              //     __html: analComIntroduction?.profile,
              //   }}
            >
              {analComIntroduction}
            </div>
          )}
          {tabActive === 'ThongTinCoBan' && (
            <PerfectScrollbar style={{ height: 'calc(100% - 5px)' }}>
              <table className="table table-borderless table-financial">
                <tbody>
                  <tr className="content">
                    <td
                      className="content-label"
                      style={{ padding: '8px 12px' }}
                    >
                      {t('algo.ptcp.txt-Listed-date')}
                    </td>
                    <td
                      className="content-text text-right"
                      style={{ padding: '8px 12px' }}
                    >
                      {formatDate(analComBasic?.firstListingDate, '/', 'dmy')}
                    </td>
                  </tr>
                  <tr className="content">
                    <td
                      className="content-label"
                      style={{ padding: '8px 12px' }}
                    >
                      {t('algo.ptcp.txt-Listed-exchange')}
                    </td>
                    <td
                      className="content-text text-right"
                      style={{ padding: '8px 12px' }}
                    >
                      {analComBasic?.exchangeCode}
                    </td>
                  </tr>
                  <tr className="content">
                    <td
                      className="content-label"
                      style={{ padding: '8px 12px' }}
                    >
                      {t('algo.ptcp.txt-Listed-price')}(x1000)
                    </td>
                    <td
                      className="content-text text-right"
                      style={{ padding: '8px 12px' }}
                    >
                      {numberFormat(analComBasic?.listedPrice / 1000, 2)}
                    </td>
                  </tr>
                  <tr className="content">
                    <td
                      className="content-label"
                      style={{ padding: '8px 12px' }}
                    >
                      {t('algo.ptcp.txt-Listed-shares')}
                    </td>
                    <td
                      className="content-text text-right"
                      style={{ padding: '8px 12px' }}
                    >
                      {numberFormat(analComBasic?.listedShares)}
                    </td>
                  </tr>
                  <tr className="content">
                    <td
                      className="content-label"
                      style={{ padding: '8px 12px' }}
                    >
                      {t('algo.ptcp.txt-Market-capitalization')}
                    </td>
                    <td
                      className="content-text text-right"
                      style={{ padding: '8px 12px' }}
                    >
                      {numberFormat(analComBasic?.marketCap)}
                    </td>
                  </tr>
                  <tr className="content">
                    <td
                      className="content-label"
                      style={{ padding: '8px 12px' }}
                    >
                      {t('algo.ptcp.txt-Outstanding-shares')}
                    </td>
                    <td
                      className="content-text text-right"
                      style={{ padding: '8px 12px' }}
                    >
                      {numberFormat(analComBasic?.outsShares)}
                    </td>
                  </tr>
                  {/* <tr className="content">
                    <td
                      className="content-label"
                      style={{ padding: '8px 12px' }}
                    >
                      {t('algo.ptcp.txt-Sector-ICB', { name: '1' })}
                    </td>
                    <td
                      className="content-text text-right"
                      style={{ padding: '8px 12px' }}
                    >
                      {
                        lang === 'vi' ? analComBasic?.level1NameVN : analComBasic?.level1NameEn
                      }
                    </td>
                  </tr> */}
                  {analComBasic?.level1NameVn && (
                    <tr className="content">
                      <td
                        className="content-label"
                        style={{ padding: '8px 12px' }}
                      >
                        {t('algo.ptcp.txt-Sector-ICB', { name: '1' })}
                      </td>
                      <td
                        className="content-text text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {lang === 'vi'
                          ? analComBasic?.level1NameVn
                          : analComBasic?.level1NameEn}
                      </td>
                    </tr>
                  )}
                  {analComBasic?.level2NameVn && (
                    <tr className="content">
                      <td
                        className="content-label"
                        style={{ padding: '8px 12px' }}
                      >
                        {t('algo.ptcp.txt-Sector-ICB', { name: '2' })}
                      </td>
                      <td
                        className="content-text text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {lang === 'vi'
                          ? analComBasic?.level2NameVn
                          : analComBasic?.level2NameEn}
                      </td>
                    </tr>
                  )}
                  {analComBasic?.level3NameVn && (
                    <tr className="content">
                      <td
                        className="content-label"
                        style={{ padding: '8px 12px' }}
                      >
                        {t('algo.ptcp.txt-Sector-ICB', { name: '3' })}
                      </td>
                      <td
                        className="content-text text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {lang === 'vi'
                          ? analComBasic?.level3NameVn
                          : analComBasic?.level3NameEn}
                      </td>
                    </tr>
                  )}
                  {analComBasic?.level4NameVn && (
                    <tr className="content">
                      <td
                        className="content-label"
                        style={{ padding: '8px 12px' }}
                      >
                        {t('algo.ptcp.txt-Sector-ICB', { name: '4' })}
                      </td>
                      <td
                        className="content-text text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {lang === 'vi'
                          ? analComBasic?.level4NameVn
                          : analComBasic?.level4NameEn}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </PerfectScrollbar>
          )}
        </Card.Body>
      </Card>
      <Card
        className=" mt-2"
        style={{
          height: 'calc(100vh - 185px)',
          background: '#020210',
        }}
      >
        <Card.Header className="py-0 pr-2 tabs-cash">
          <PerfectScrollbar style={{ height: '37px' }}>
            <div className="d-flex">
              <a
                className={
                  'fz-14 ' + (companyActive === 'CtyCon' ? 'active' : '')
                }
                style={{ padding: '8px 0' }}
                onClick={() => setCompanyActive('CtyCon')}
              >
                {t('algo.ptcp.txt-Subsidiaries')}
              </a>
              <a
                className={
                  'fz-14 ' + (companyActive === 'CtyLienKet' ? 'active' : '')
                }
                style={{ padding: '8px 0' }}
                onClick={() => setCompanyActive('CtyLienKet')}
              >
                {t('algo.ptcp.txt-Associates')}
              </a>
              <a
                className={
                  'fz-14 ' + (companyActive === 'CtyKhac' ? 'active' : '')
                }
                style={{ padding: '8px 0' }}
                onClick={() => setCompanyActive('CtyKhac')}
              >
                {t('algo.ptcp.txt-Others')}
              </a>
            </div>
          </PerfectScrollbar>
        </Card.Header>
        <Card.Body className="p-0">
          <PerfectScrollbar style={{ height: 'calc(100% - 5px)' }}>
            <table className="table table-borderless table-financial">
              <tbody>
                <tr className="content">
                  <td className="content-label">{t('algo.ptcp.txt-Name')}</td>
                  <td className="content-label text-right text-nowrap">
                    {t('algo.ptcp.txt-Capital-bil')}
                  </td>
                  <td className="content-label text-right text-nowrap">
                    {t('algo.ptcp.txt-ownership')} (%)
                  </td>
                </tr>
                {analComRelated &&
                  analComRelated.map((item, index) => (
                    <tr key={index}>
                      <td
                        className="txt-content"
                        style={{ padding: '8px 12px' }}
                      >
                        {item.relatedCompanyName}
                      </td>
                      <td
                        className="txt-content text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {numberFormat(item.charterCapital, 1, '-')}{' '}
                        {/* {t('algo.bdkt.txt-bil')} */}
                      </td>
                      <td
                        className="txt-content text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {numberFormat(item.ownerShip, 2, '-')}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {(!analComRelated || !analComRelated.length) && <NoDataFound />}
          </PerfectScrollbar>
        </Card.Body>
      </Card>
      <Card
        className="mt-2"
        style={{
          height: 'calc(100vh - 185px)',
          background: '#020210',
        }}
      >
        <Card.Header style={{ padding: '8px 16px' }}>
          <span className="color-white fz-14">{t('algo.ptcp.txt-Peers')}</span>
        </Card.Header>
        <Card.Body className="p-0">
          <PerfectScrollbar style={{ height: 'calc(100% - 5px)' }}>
            <table className="table table-borderless table-financial">
              <tbody>
                <tr className="content">
                  <td className="content-label">{t('algo.ptcp.txt-Ticker')}</td>
                  <td className="content-label text-right">
                    {t('algo.ptcp.txt-Price')}
                  </td>
                  <td className="content-label text-right">
                    {t('algo.ptcp.txt-vol')}
                  </td>
                </tr>

                {ctyCungNganh &&
                  ctyCungNganh.map((item, index) => (
                    <tr key={index}>
                      <td
                        className={item.Color || 'txt-content'}
                        style={{ padding: '8px 12px' }}
                      >
                        {item.CompanyID}
                      </td>
                      <td
                        className={
                          ' text-right d-grid ' +
                          (colorFix(
                            item.FinishPrice,
                            item.RefPrice,
                            item.CeilingPrice,
                            item.FloorPrice,
                            item.RefPrice
                          ) || 'txt-content')
                        }
                      >
                        <span>{numberFormat(item.FinishPrice, 2, '0')}</span>
                        <span>({numberFormat(item.DiffRate, 2, '0')}%)</span>
                      </td>
                      <td
                        className="txt-content text-right"
                        style={{ padding: '8px 12px' }}
                      >
                        {numberFormat(item.TotalShare, 0, '0')}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {isLoading && <Loading />}
          </PerfectScrollbar>
        </Card.Body>
      </Card>
      <Card
        className="mt-2"
        style={{
          height: 'calc(100vh - 185px)',
          background: '#020210',
        }}
      >
        <Card.Header className="d-flex py-0 pr-2 tabs-cash">
          <a
            className={
              'fz-14 ' + (leaderActive === 'BanLanhDao' ? 'active' : '')
            }
            style={{ padding: '8px 0' }}
            onClick={() => setLeaderActive('BanLanhDao')}
          >
            {t('algo.ptcp.txt-Board-managers')}
          </a>
          <a
            className={
              'fz-14 ' + (leaderActive === 'CoDongLon' ? 'active' : '')
            }
            style={{ padding: '8px 0' }}
            onClick={() => setLeaderActive('CoDongLon')}
          >
            {t('algo.ptcp.txt-Large-shareholders')}
          </a>
        </Card.Header>
        <Card.Body className="p-0">
          <PerfectScrollbar style={{ height: 'calc(100% - 5px)' }}>
            {leaderActive === 'BanLanhDao' && (
              <>
                <table className="table table-borderless table-financial top-holder-ranking">
                  <tbody>
                    {analComLeader &&
                      analComLeader.map((item, index) => (
                        <tr key={index}>
                          <td style={{ padding: '8px 12px' }}>
                            <div className="d-grid" style={{ gap: '4px' }}>
                              <span className="txt-content">
                                {lang === 'vi'
                                  ? item.fullName
                                  : item.fullNameEn}
                              </span>
                              <span className="sub-content">
                                {lang === 'vi'
                                  ? item.position
                                  : item.positionEn}
                              </span>
                            </div>
                          </td>
                          <td
                            className="text-right"
                            style={{ padding: '8px 12px' }}
                          >
                            <div className="d-grid" style={{ gap: '4px' }}>
                              <span className="txt-content">
                                {numberFormat(item.personalHeld, 0, '0')}
                              </span>
                              <span className="txt-content">
                                {numberFormat(item.personalHeldPct, 2, '0')}%
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {(!analComLeader || !analComLeader.length) && <NoDataFound />}
              </>
            )}
            {leaderActive === 'CoDongLon' && (
              <>
                <table className="table table-borderless table-financial top-holder-ranking">
                  <tbody>
                    {analComHolder &&
                      analComHolder.map((item, index) => (
                        <tr key={index}>
                          <td style={{ padding: '8px 12px' }}>
                            <span className="txt-content">
                              {lang === 'vi' ? item.name : item.nameEn}
                            </span>
                          </td>
                          <td
                            className="text-right"
                            style={{ padding: '8px 12px' }}
                          >
                            <span className="txt-content">
                              {numberFormat(item.currentHeld, 0, '0')}
                            </span>
                          </td>
                          <td
                            className="text-right"
                            style={{ padding: '8px 12px' }}
                          >
                            <span className="txt-content">
                              {numberFormat(item.heldPct, 2, '0')}%
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {(!analComHolder || !analComHolder.length) && <NoDataFound />}
              </>
            )}
          </PerfectScrollbar>
        </Card.Body>
      </Card>
    </div>
  )
}

const makeMapStateToProps = () => {
  const getAnalComIntroduction = makeGetAnalComIntroduction()
  const getAnalComBasic = makeGetAnalComBasic()
  const getAnalComSameInd = makeGetAnalComSameInd()
  const getAnalComLeader = makeGetAnalComLeader()
  const getAnalComHolder = makeGetAnalComHolder()

  const getAnalComRelated = makeGetAnalComRelated()

  const mapStateToProps = (state) => {
    return {
      analComIntroduction: getAnalComIntroduction(state),
      analComBasic: getAnalComBasic(state),
      analComSameInd: getAnalComSameInd(state),
      analComLeader: getAnalComLeader(state),
      analComHolder: getAnalComHolder(state),

      analComRelated: getAnalComRelated(state),
      lang: state.client?.setting?.lang || 'vi',
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps)(memo(PanelFiles))
